export const channels = {
  sms: 'SMS',
  email: 'EMAIL',
  mpush: "MOBILEPUSH",
  call_task: 'CALL_TASK',
  wechat: 'WECHAT',
  facebook: 'FACEBOOK',
  line: 'LINE',
  viber: 'VIBER',
  whatsapp: 'WHATSAPP',
  rcs: "RCS",
  zalo: "ZALO",
  inapp: "INAPP",
};
export const BIG_PICTURE = "BIG_PICTURE";